import {Form} from '../../../stores/Form/Form';
import {addNewStandAloneForm} from '../../Form/actions/standAloneForm';
import {addAndApplyFilters} from '../../Form/actions/filters';
import {priority} from '@priority-software/priority-proto-api/lib';
import {startAndFetchSubform} from '../../Form/actions/batchedActions/standAloneFormBatch';

export const getCashForm = async (): Promise<Form> => {
    const form = await addNewStandAloneForm('CASH_CASH', {}, undefined, 0);
    const id = form.columns.find(x => x.Name === 'BALANCE3').id;
    return addAndApplyFilters(form, [
        {
            fieldId: id,
            value: '*',
            operator: priority.netitems.shared.ComparisonOperator.Eq
        }
    ]);
};

export const getCashBalSubForm = async (form: Form): Promise<Form> => {
    await startAndFetchSubform(form, 'CASHBAL');
    return form.activeSubForm;
};
